import Button, { LoadingButton } from '@atlaskit/button';
import { Box } from '@fuegokit/react';
import { useNavigate } from 'react-router-dom';

import { DisabledTrackingUser } from '../../components/users-dashboard/DisabledTrackingUser';
import { LastEntryDetails } from '../../components/users-dashboard/LastEntryDetails';
import { LoadingItems } from '../../components/users-dashboard/LoadingItems';
import { useLastUserEntries } from '../../hooks/useLastUserEntries';

export function ConfigUsers() {
  const navigate = useNavigate();
  const { entries, loadMore, users, loading, hasMore } = useLastUserEntries();

  function onNavigate() {
    navigate('/configuration');
  }

  const shouldShowLoadMore = entries.length > 0 && hasMore;

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column">
      <Box py={4}>
        To share tracking status with other Jira instance users you need to go
        to{' '}
        <Button spacing="none" appearance="link" onClick={onNavigate}>
          app configuration
        </Button>{' '}
        tab and select specific Toggl workspace and project to share.
      </Box>
      <Box overflow="auto" pr={3}>
        <Box
          width="100%"
          display="grid"
          gridTemplateColumns="repeat(auto-fill, minmax(270px, 1fr))"
          gridAutoRows="minmax(0, 275px)"
          gridGap="18px"
        >
          {entries.map((entry, index) =>
            entry.isSharing ? (
              <LastEntryDetails
                user={users[entry.accountId]}
                key={index}
                details={entry}
              />
            ) : (
              <DisabledTrackingUser user={users[entry.accountId]} key={index} />
            )
          )}
          {loading && <LoadingItems />}
        </Box>
      </Box>

      {shouldShowLoadMore && (
        <Box p={4} display="flex" justifyContent="center" alignItems="center">
          <LoadingButton
            isDisabled={!hasMore}
            isLoading={loading}
            onClick={loadMore}
          >
            Load More...
          </LoadingButton>
        </Box>
      )}
    </Box>
  );
}
